/**
 * Timeline data transformation utilities
 */

import { TimelineEventData } from 'src/v3/components/timeline/ModularTimeline'
import { darkTheme } from 'src/theme'
import {
  TimelineEvent,
  isCEActivity,
  isUserAction,
  isLicenseActivity,
  isCredentialActivity,
} from '../types'

/**
 * Transform TimelineEvent from API to ModularTimeline format
 */
export function transformToModularTimelineEvent(
  event: TimelineEvent,
): TimelineEventData {
  // Get color from theme entity colors
  let { palette } = darkTheme
  let { entityColors } = palette as any

  // Use the API's type directly - it returns the correct display value
  let eventType = event.type

  // Use consistent color for all CE activities
  let eventColor = (() => {
    if (isCEActivity(event.data)) {
      return entityColors.ceActivity // All CE activities use same teal color
    }
    if (isUserAction(event.data)) {
      return entityColors.userAction
    }
    if (isLicenseActivity(event.data)) {
      return entityColors.licenseActivity
    }
    if (isCredentialActivity(event.data)) {
      return entityColors.credentialActivity
    }
    return entityColors[eventType] // Assignments, events, and others use their specific colors
  })()

  return {
    id: event.id,
    title: event.title,
    description: event.description,
    timestamp: event.timestamp || null,
    type: eventType,
    color: eventColor,
    metadata: event.metadata || [],
    actions: (event.actions || []).map((action) => ({
      label: action.label,
      onClick: () => {
        // Will be handled by parent component based on action.action
      },
      variant: action.variant,
    })),
    data: event, // Pass full event for modal access
  }
}
